import React from "react";

// styles
import styles from "./Banner.module.scss";

const Banner = ({
  SuffixIcon,
  PrefixIcon,
  title,
  btnLabel,
  priceLabel,
  rounded,
  handleClick,
}) => {
  return (
    <div className={styles.banner__root}>
      <p className={styles.title__wrapper}>
        {priceLabel && (
          <span className={styles.label}>
            Ticket from / <i>${priceLabel}</i>
          </span>
        )}
        <span className={styles.title}>{title}</span>
      </p>
      <button className={styles[rounded]} onClick={handleClick}>
        {SuffixIcon && <SuffixIcon />}
        <span>{btnLabel}</span>
        {PrefixIcon && <PrefixIcon />}
      </button>
    </div>
  );
};

export default Banner;
